import React from 'react';

// Material UI
import MuiTable from '@mui/material/Table';

function Table({isDesktop = false, ...props}) {
    return (
        <MuiTable
            sx={{
                ...isDesktop && {
                    borderCollapse:'separate',
                    borderSpacing: '0 8px',
                }
            }}
            {...props}
        >
            {props.children}
        </MuiTable>
    )
}

export default Table;
